import { render } from "./Sistema.vue?vue&type=template&id=27a5e3d0"
import script from "./Sistema.vue?vue&type=script&lang=ts"
export * from "./Sistema.vue?vue&type=script&lang=ts"
script.render = render

export default script